import React from "react";
import { Link } from "react-router-dom";
import ImageIcon from "./ImageIcon";

type propsType = {
  type?: "submit" | "reset" | "button" | undefined;
  customeStyle: string;
  href?: string;
  text: string | any;
  width: string;
  Icon?: () => JSX.Element;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  imageIcon?: any;
  buttonProps?: any;
  isRequesting?: boolean;
  children?: React.ReactNode;
};

const Button = ({
  type,
  customeStyle,
  href,
  text,
  width,
  imageIcon,
  isRequesting = false,
  onClick,
  Icon,
  buttonProps,
  children,
}: propsType) => {
  return (
    <div className={width}>
      <button
        type={type ? type : "button"}
        className={customeStyle}
        onClick={onClick}
        {...buttonProps}
      >
        {Icon && <Icon />}
        {imageIcon && (
          <img loading="lazy" className="w-8" src={imageIcon} alt="" />
        )}
        {href ? (
          <Link className="w-full block" to={href}>
            {text}
          </Link>
        ) : isRequesting ? (
          <span className="btnSpinner"></span>
        ) : (
          text
        )}
        {children}
      </button>
    </div>
  );
};

export default Button;
